module.exports = __webpack_public_path__ + "img/dz.23b3566a.png";